import {
  UNPAID_STATUSES,
  UNPAID_STATUS_LABEL,
  UNPAID_STATUS_STYLES,
  UnpaidInvoicesResponse,
  UnpaidStatus,
} from "../../../types/impagos";

type Props = {
  aggregates: UnpaidInvoicesResponse["aggregates"];
  total: number;
  selectedStatuses: UnpaidStatus[];
  onToggleStatus: (s: UnpaidStatus) => void;
};

const fmtMoney = (n: number): string =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export default function AggregatesBar({
  aggregates,
  total,
  selectedStatuses,
  onToggleStatus,
}: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "0.65rem",
        background: "white",
        padding: "0.75rem 1rem",
        borderRadius: "0.6rem",
        boxShadow: "0 1px 3px rgba(0,0,0,.04)",
        borderLeft: "3px solid #b32424",
        marginBottom: "0.75rem",
      }}
    >
      <div style={{ marginRight: "0.5rem" }}>
        <div
          style={{
            fontSize: ".7rem",
            color: "#73879C",
            textTransform: "uppercase",
            letterSpacing: ".4px",
            fontWeight: 600,
          }}
        >
          Total impagado
        </div>
        <div
          style={{
            fontSize: "1.4rem",
            fontWeight: 700,
            color: "#b32424",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {fmtMoney(aggregates.totalAmount)}
        </div>
        <div style={{ fontSize: ".75rem", color: "#73879C" }}>
          {total} facturas
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "0.45rem",
          flexWrap: "wrap",
          marginLeft: "auto",
        }}
      >
        {UNPAID_STATUSES.map((status) => {
          const count = aggregates.countsByStatus[status] ?? 0;
          const active = selectedStatuses.includes(status);
          const style = UNPAID_STATUS_STYLES[status];
          return (
            <button
              key={status}
              type="button"
              onClick={() => onToggleStatus(status)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.4rem",
                padding: "0.35rem 0.7rem",
                borderRadius: "0.45rem",
                background: active ? style.bg : "white",
                color: active ? style.fg : "#1f2933",
                border: `1px solid ${active ? style.bg : "#dee2e6"}`,
                fontSize: ".78rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
              title={
                active ? "Click para quitar filtro" : "Click para filtrar por este estado"
              }
            >
              <span>{UNPAID_STATUS_LABEL[status]}</span>
              <span
                style={{
                  background: active ? "rgba(255,255,255,.25)" : "#e9ecef",
                  color: active ? "inherit" : "#73879C",
                  padding: "0.05rem 0.4rem",
                  borderRadius: "999px",
                  fontSize: ".7rem",
                  fontWeight: 700,
                  minWidth: 20,
                  textAlign: "center",
                }}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
